// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { QueryStringMatch } from './queryStringMatch.js';
import type { TCSPromotionSearchScope } from './tCSPromotionSearchScope.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentPatientSearchRequestModel {
    'maxResults'?: number;
    'skipRows'?: number;
    'firstNameQueryType'?: QueryStringMatch;
    'firstName'?: string;
    'lastNameQueryType'?: QueryStringMatch;
    'lastName'?: string;
    'dateOfBirth'?: string;
    'city'?: string;
    'state'?: string;
    'postalCode'?: string;
    'country'?: string;
    'memberNumber'?: string;
    'email'?: string;
    'phone'?: string;
    'alternateId'?: string;
    'promotionSearchScope'?: TCSPromotionSearchScope;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentPatientSearchRequestModel>> = [
        {
            "name":     "maxResults",
            "baseName": "maxResults",
            "type":     "number"
        },
        {
            "name":     "skipRows",
            "baseName": "skipRows",
            "type":     "number"
        },
        {
            "name":     "firstNameQueryType",
            "baseName": "firstNameQueryType",
            "type":     "QueryStringMatch"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastNameQueryType",
            "baseName": "lastNameQueryType",
            "type":     "QueryStringMatch"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "postalCode",
            "baseName": "postalCode",
            "type":     "string"
        },
        {
            "name":     "country",
            "baseName": "country",
            "type":     "string"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "alternateId",
            "baseName": "alternateId",
            "type":     "string"
        },
        {
            "name":     "promotionSearchScope",
            "baseName": "promotionSearchScope",
            "type":     "TCSPromotionSearchScope"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentPatientSearchRequestModel.attributeTypeMap;
    }
}
